import styled from 'styled-components';

export const Container = styled.button<{ hasUrl: boolean }>`
  ${({ hasUrl }) => hasUrl && 'cursor: pointer;'}
  background: none;
  border: none;
  padding: 0;
  margin: 0;
`;

const Image = styled.img`
  border-radius: 4px;
  width: 100%;
  height: 100%;
  display: block;
`;

export { Image };
